module.exports = __webpack_public_path__ + "img/nav3h.af21236b.png";